import axios from "axios";
import { $userInfoBd } from "../store/user";
import { defaultPath } from "./defaultPath";

export const achievements = {
    get: async () => {
        const user_id = $userInfoBd.getState()?.id;
        const res = await axios.get(`${defaultPath}achievements/${user_id}`);
        
        return res.data;
    },
    addToCollection: async (achievement_id:string) => {
        const user_id = $userInfoBd.getState()?.id + '';
        const res = await axios.post(`${defaultPath}api/user/achievements`, { user_id, achievement_id });

        return res.data;
    },
}